module.exports = __webpack_public_path__ + "img/lootbox_preview_frame.3e376c10.png";